import { createContext, useContext } from 'react';

/**
 * Places in the topbar a page can render into, so the page's name and its
 * actions sit in the bar the reference admin keeps them in, instead of a
 * second header under it saying the same thing.
 *
 *   title    beside the section in the crumb; replaces the nav's own label
 *   actions  the right end of the bar, after the shop's status
 *
 * The layout owns the elements and the page portals into them (see
 * `PageHeader`). A portal keeps the page's React context, so an action wired
 * to the page's state still works from up there.
 *
 * The layout watches the actions slot itself: when a page puts a filled
 * button there, the global New bill steps down to a secondary one, so the bar
 * never carries two filled buttons.
 */
export type TopbarSlots = {
  title: HTMLElement | null;
  actions: HTMLElement | null;
};

export const TopbarSlotsContext = createContext<TopbarSlots | null>(null);

/** Null outside the app shell, where a page header renders in place instead. */
export function useTopbarSlots(): TopbarSlots | null {
  return useContext(TopbarSlotsContext);
}
